import { h, render } from 'preact'
import App from './App'
require('preact/devtools')
import ConfigProvider from './config/ConfigProvider'

if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
        'use strict'
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined')
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function')
        }
        var list = Object(this)
        var length = list.length >>> 0
        var thisArg = arguments[1]
        var value
  
        for (var i = 0; i < length; i++) {
            value = list[i]
            if (predicate.call(thisArg, value, i, list)) {
                return value
            }
        }
        return undefined
    }
}

if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function(predicate) {
            'use strict'
            if (this == null) {
                throw new TypeError('Array.prototype.findIndex called on null or undefined')
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function')
            }
            var list = Object(this)
            var length = list.length >>> 0
            var thisArg = arguments[1]
            var value

            for (var i = 0; i < length; i++) {
                value = list[i]
                if (predicate.call(thisArg, value, i, list)) {
                    return i
                }
            }
            return -1
        },
        enumerable: false,
        configurable: false,
        writable: false
    })
}

let container = $('#limba-style-generator').eq(0)
export const IMAGE_URL = container.data('image-url')
export const API_URL = container.data('api-url')

jQuery($ => {
    render(<ConfigProvider><App /></ConfigProvider>, container[0])
})

 


// WEBPACK FOOTER //
// ./js/main.js